// extracted by mini-css-extract-plugin
export default {"status":"StatusCell_status__43Ks9","active":"StatusCell_active__RBUlh","inactive":"StatusCell_inactive__-SVkC"};